import { Niveau } from './niveau.model';
import { PhotoLieu } from './photoLieu.model';

export class Piece {
    id: number;
    longueur: number;
    largeur: number;
    hauteur: number;
    nom_niveau: string;
    niveau_id: number;
    nom_piece: string;
    nom_piece_id: number;
    photos_lieux: PhotoLieu;
    revetement_plancher: string;

    public constructor(init?: Partial<Piece>) {
      Object.assign(this, init);
    }
  }
